$.datepicker.regional.en = {
    closeText: 'Done',
    prevText: 'Prev',
    nextText: 'Next',
    currentText: 'Today',
    monthNames: [ 'January','February','March','April','May','June',
        'July','August','September','October','November','December' ],
    monthNamesShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ],
    dayNames: [ 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ],
    dayNamesShort: [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ],
    dayNamesMin: [ 'S','M','T','W','T','F','S' ],
    weekHeader: 'Wk',
    dateFormat: 'dd/mm/yy',
    firstDay: 0,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
};



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonCalendar/DatePickerSettings.js
// module id = 161
// module chunks = 0